export default __webpack_public_path__ + "static/media/Ballroll_00253.ef70e693.png";